import React from 'react';
import { AreaSVGProps } from '../VehiclePaintMeasurement.types';

export const AreaC_Hatchback_Right: React.FC<AreaSVGProps> = ({
  fill = '#FFD91B',
  stroke = '#FFD91B',
  strokeWidth = 2,
  fillOpacity = 0.5,
  className = '',
}) => {
  return (
    <svg
      width="106"
      height="182"
      viewBox="0 0 106 182"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        <filter
          id="filter_area_c_hatchback_right"
          x="0"
          y="0"
          width="106"
          height="182"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
      </defs>
      <g filter="url(#filter_area_c_hatchback_right)">
        <path
          d="M105.614 4.61655e-06C88.2878 5.10023 56.5858 11.9808 31.7412 11.2227C25.7168 11.1819 19.3354 9.64374 14.0791 7.30762L0 125.843L42.9033 181.803L60.3545 172.02C55.593 163.44 52.8275 153.157 52.4746 141.12L52.4736 141.103V141.085C52.1628 125.912 54.3236 110.936 64.0439 96.3467L64.084 96.2871L64.125 96.2295L64.835 95.2549C68.4326 90.3802 72.7883 85.4985 79.085 81.3525C85.1733 77.3438 92.8927 74.1425 103.195 72.1504C103.218 71.4631 103.243 70.6689 103.272 69.7715C103.394 66.0856 103.573 60.6499 103.806 53.6504C104.236 40.7163 104.85 22.4421 105.614 4.61655e-06Z"
          fill={fill}
          fillOpacity={fillOpacity}
          stroke={stroke}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
          shapeRendering="crispEdges"
        />
      </g>
    </svg>
  );
};
